// 花式控制台打印
export function patternPrint(title, content) {
	console.log(
		`%c ${title} %c ${content} `,
		'padding: 1px; border-radius: 3px 0 0 3px; color: #fff; background: #606060;',
		'padding: 1px; border-radius: 0 3px 3px 0; color: #fff; background: #1475B2;'
	);
}
